<template>
  <div class="shadow-md rounded-md" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Card",
  emits: ["click"],
  setup(props, { emit }) {
    const handleClick = (e) => {
      emit("click", e);
    };

    return {
      handleClick,
    };
  },
};
</script>

<style></style>
